import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

export default function ScoreHistoryChart({ data = [] }) {
  // Sécurité : Si data n'est pas un tableau ou est vide, on affiche un état "Initialisation"
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="h-[300px] w-full flex flex-col items-center justify-center bg-zinc-900/50 border border-zinc-800 border-dashed rounded-sm">
        <p className="text-zinc-600 font-mono text-[10px] uppercase tracking-widest">
          Waiting_for_telemetry_data...
        </p>
      </div>
    );
  }

  return (
    <div className="h-[300px] w-full bg-zinc-900/30 p-2 rounded-sm">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="cyberGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
            </linearGradient>
          </defs>
          
          <CartesianGrid 
            strokeDasharray="3 3" 
            vertical={false} 
            stroke="#27272a" 
          />
          
          <XAxis 
            dataKey="date" 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#52525b', fontSize: 10, fontFamily: 'monospace' }}
            dy={10}
          />
          
          <YAxis 
            domain={[0, 100]} 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#52525b', fontSize: 10, fontFamily: 'monospace' }}
          />

          <Tooltip 
            cursor={{ stroke: '#3b82f6', strokeWidth: 1 }}
            contentStyle={{ 
              backgroundColor: '#09090b', 
              border: '1px solid #3b82f6',
              borderRadius: '0px',
              fontSize: '10px',
              fontFamily: 'monospace',
              color: '#fff'
            }}
            itemStyle={{ color: '#3b82f6' }}
            labelStyle={{ color: '#52525b', marginBottom: '4px' }}
          />

          <Area
            type="monotone"
            dataKey="score"
            stroke="#3b82f6"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#cyberGradient)"
            animationDuration={2000}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
